import ChatGPTLogoImg from "@/assets/chatgpt.png"; // <-- Klarer Bildimport
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const ChatGPTLogo = (props: Props) => (
  <LogoImage imgSrc={ChatGPTLogoImg} alt="ChatGPT Logo" size="navbar" {...props} />
);
